<div *ngIf="topBarVisible$ | async" class="app-top-loader-bar pointer-events-none">
  <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
</div>
